module.exports = __webpack_public_path__ + "img/2.59a14d52.jpg";